<div class="status-modal">
    <div class="close-modal" (click)="activeModal.close('')">
        <img appImageSelector alt="mt-image" imageType="icon" imageKey="close">
    </div>

    <div class="title">
        <h6>{{machineName}}</h6>
        <span class="text-time">{{textTime}}</span>
    </div>

    <div class="message" *ngIf="availableStatus">
        <table class="table table-striped" aria-label="table-status-modal">
            <thead>
                <tr>
                    <th>
                        {{'status' | lang | uppercase}}
                        <select *ngIf="statusToSelect" class="form-control status-select" (change)="changeStatus($event)">
                            <option [value]="'all'">Todos</option>
                            <ng-container *ngFor="let status of statusToSelect">
                                <option [value]="status" *ngIf="status === selectedStatus" selected="selected">{{status}}</option>
                                <option [value]="status" *ngIf="status !== selectedStatus">{{status}}</option>
                            </ng-container>
                        </select>
                    </th>
                    <th>%</th>
                    <th>{{'time' | lang | uppercase}}</th>
                </tr>
            </thead>

            <tbody *ngIf="statusShowing">
                <tr *ngFor="let status of statusShowing">
                    <td><img appImageSelector alt="mt-image" [imageType]="'dashboard-' + machineType" [imageKey]="status.imageName"> {{status.name}} </td>
                    <td>{{status.percentage}} %</td>
                    <td>{{status.hours}}</td>
                </tr>
            </tbody>

            <tfoot *ngIf="statusShowing">
                <tr>
                    <td colspan="2">
                        {{'showing' | lang}}
                        {{statusShowing.length > 6 ? '6' : statusShowing.length}}
                        {{'from-total-of' | lang}} {{totalRegister.length}}
                    </td>

                    <td>
                        <div class="flex-row">
                            <div class="paginator mt-shadowed" (click)="paginate(page - 1)" *ngIf="page > 1">
                                <em class="material-icons">arrow_left</em>
                            </div>

                            <div>
                                {{page}} {{'of' | lang}} {{totalPages}}
                            </div>

                            <div class="paginator mt-shadowed" (click)="paginate(page + 1)" *ngIf="totalPages !== page">
                                <em class="material-icons">arrow_right</em>
                            </div>
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>

    <div class="separator"></div>
</div>